// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__thJYx","log":"ModalInventoryLogs_log__2mwzy","date":"ModalInventoryLogs_date__3U-Ys","userName":"ModalInventoryLogs_userName__2XsSE"};